module.exports = __webpack_public_path__ + "media/images/page/ico_medal2-fb8c4162b70badf5db1af889766f1d26.svg";